import { useLang } from "../../lib/i18n";

export const LangToggle = ({ className = "", idSuffix = "" }) => {
    const { lang, setLang } = useLang();
    const suffix = idSuffix ? `-${idSuffix}` : "";
    return (
        <div
            data-testid={`lang-toggle${suffix}`}
            className={`flex items-center gap-0.5 rounded-full border border-white/15 bg-night-950/60 p-0.5 font-mono text-[11px] backdrop-blur-sm ${className}`}
        >
            {["nl", "en"].map((code) => (
                <button
                    key={code}
                    onClick={() => setLang(code)}
                    data-testid={`lang-toggle-${code}${suffix}`}
                    aria-label={code === "nl" ? "Nederlands" : "English"}
                    className={`rounded-full px-3 py-1.5 font-bold uppercase tracking-widest transition-[background-color,color] duration-300 ${
                        lang === code
                            ? "bg-amber-400 text-night-950"
                            : "text-slate-400 hover:text-white"
                    }`}
                >
                    {code}
                </button>
            ))}
        </div>
    );
};
